export default {"src":"/_next/static/media/whatsApp.770248cd.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};